export const ASSESSMENT_TYPES = {
  CALIBRATION: 'calibration',
  HOLLAND: 'holland',
  BIGFIVE: 'bigfive',
  WONDERLIC: 'wonderlic',
  GARDNER: 'gardner',
  REAN: 'rean',
};

export const HOLLAND_KEYS = ['R', 'I', 'A', 'S', 'E', 'C'];
export const BIGFIVE_KEYS = ['K', 'B', 'E', 'C', 'T'];
export const INTELLIGENCE_KEYS = [
  'logical', 'visual', 'intrapersonal', 'social',
  'musical', 'linguistic', 'kinesthetic', 'naturalistic',
];
export const CLUSTER_KEYS = ['ambition', 'resilience', 'achievement', 'learning'];

export const PHASE_INFO = {
  calibration: { titleKey: 'phaseTitleCalibration', bodyKey: 'phaseBodyCalibration', minutes: 2 },
  holland: { titleKey: 'phaseTitleHolland', bodyKey: 'phaseBodyHolland', minutes: 10 },
  bigfive: { titleKey: 'phaseTitleBigfive', bodyKey: 'phaseBodyBigfive', minutes: 10 },
  // Wonderlic minutes intentionally omitted: this phase is server-timed, so
  // the intro card reads the value from `currentPhase.timeLimitSeconds`
  // instead of a static estimate. Other phases stay estimate-only.
  wonderlic: { titleKey: 'phaseTitleWonderlic', bodyKey: 'phaseBodyWonderlic' },
  gardner: { titleKey: 'phaseTitleGardner', bodyKey: 'phaseBodyGardner', minutes: 10 },
  rean: { titleKey: 'phaseTitleRean', bodyKey: 'phaseBodyRean', minutes: 10 },
};
